import { Authorities, AuthorizedRepresentativeView } from '../../types/AuthorizedRepresentative';
import { CustomerInstantLease } from '../../types/CustomerInstantLease';

export default function transformAuthorizedRepresentatives(data: CustomerInstantLease): AuthorizedRepresentativeView[] {
    if (data?.authorizedRepresentatives) {
        return data?.authorizedRepresentatives.map((value) => {
            return {
                firstName: value?.person?.firstName || 'n/a',
                lastName: value?.person?.lastName || 'n/a',
                role: (value?.role || []).map((val: unknown) => Authorities[val as keyof typeof Authorities]),
            };
        });
    }
    return [];
}
